import {
  API_CONFIG_QUERY_KEY,
  createAccountQueryKey,
} from 'constants/QueryKeys.constants';

export const useGetApiConfigQueryKey = (accountId: string) =>
  createAccountQueryKey(accountId, API_CONFIG_QUERY_KEY);

export const useGetApiConfigMetricsQueryKey = (accountId: string) =>
  createAccountQueryKey(accountId, API_CONFIG_QUERY_KEY, 'metrics');
